import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Error } from '@carvana/purchase-styles';
class ErrorBoundary extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired
  };

  state = {
    errorInfo: null,
    error: null,
    eventId: null
  };

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
  }

  render() {
    const { children } = this.props;
    const { errorInfo } = this.state;

    if (errorInfo) {
      return <Error {...this.state} />;
    }

    return children;
  }
}

export default ErrorBoundary;
